module.exports = __webpack_public_path__ + "static/media/combustivel.e32f992d.png";